import { FC } from "react";
import { useForm, Controller } from "react-hook-form";
import { InputWithValidation } from "./InputWithValidation";

interface IRules {
  required?: string;
  pattern?: RegExp;
  validate?: (value: string) => any;
}

export interface IInput {
  name: string;
  ref?: any;
  control: any;
  rules?: IRules;
  label?: string;
  iconSize?: number;
  placeholder?: string;
  isDisabled?: boolean;
  isRequired?: boolean;
  isShadow?: boolean;
  isSearch?: boolean;
  icon?: string;
  value?: string | number;
  onChange?: (arg: string) => void;
  onBlur?: () => void;
}

const Input: FC<IInput> =(props): JSX.Element => {
  const { control, name, rules, onChange, onBlur } = props;

  useForm({
    mode: 'onBlur'
  })

  return (
    <>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState, formState }) => {
          return (
            <>
              <InputWithValidation
                {...props}
                value={field.value}
                onChange={(value) => {
                  field.onChange(value);
                  onChange && onChange(value);
                }}
                onBlur={onBlur}
                error={fieldState.error?.message}
              />
            </>
          );
        }}
      />
    </>
  )
}

export default Input;